import { Avatar as UiAvatar, AvatarFallback, AvatarImage } from '@radix-ui/react-avatar';
import { type VariantProps, cva } from 'class-variance-authority';

import { cn } from '../../utils';

const avatarVariants = cva(
  'inline-flex items-center justify-center overflow-hidden bg-avatar-background rounded-md text-xs font-semibold text-weak shrink-0',
  {
    variants: {
      size: {
        small: 'size-6 rounded-sm text-[0.625rem]/3',
        medium: 'size-8',
        large: 'size-10',
        huge: 'size-12',
      },
    },
    defaultVariants: {
      size: 'small',
    },
  },
);

export interface AvatarProps extends VariantProps<typeof avatarVariants> {
  src?: string;
  alt?: string;
  fallback?: string;
}

function Avatar({ size, src, fallback, alt }: AvatarProps) {
  // We limit the number of initials to 2 because we want to avoid the avatar being too large.
  const fallbackInitials = fallback
    ?.split(' ')
    .slice(0, 2)
    .reduce((acc, word) => acc + word[0], '');

  return (
    <UiAvatar className={cn(avatarVariants({ size }))}>
      <AvatarImage alt={alt ?? 'Avatar'} src={src} />
      <AvatarFallback>{fallbackInitials}</AvatarFallback>
    </UiAvatar>
  );
}

export { avatarVariants, Avatar };
